import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { hasAuthToken } from '../auth/services/auth.utils';

export const WelcomeGuard: CanActivateFn = () => {
  const router = inject(Router);
  return !hasAuthToken() ? router.parseUrl('/auth/sign-up/yearly') : router.parseUrl('/app/home');
};
